var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z",
    fill: "#4B4AD5",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2531_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0901 22C19.0901 22.8284 19.7617 23.5 20.5901 23.5C21.4186 23.5 22.0901 22.8284 22.0901 22H19.0901ZM1.91016 22C1.91016 22.8284 2.58173 23.5 3.41016 23.5C4.23858 23.5 4.91016 22.8284 4.91016 22H1.91016ZM22.0901 22C22.0901 17.0283 17.2659 13.5 12.0002 13.5V16.5C16.2144 16.5 19.0901 19.2317 19.0901 22H22.0901ZM12.0002 13.5C6.7344 13.5 1.91016 17.0283 1.91016 22H4.91016C4.91016 19.2317 7.7859 16.5 12.0002 16.5V13.5Z",
    fill: "#4B4AD5",
    mask: "url(#path-2-inside-1_2531_9634)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.2c2e64b49dda5fd1275ba366ba2dc957.svg";
export { ForwardRef as ReactComponent };